export enum CompareDirection {
  Asc = 'asc',
  Desc = 'desc'
}
